<div [innerHTML]="news" *ngIf="news"
     [style.backgroundColor]="newsStyle.backgroundColor"
     [style.color]="newsStyle.color"
     [style.fontSize]="newsStyle.fontSize" class="message" [ngClass]="show ? '' : 'hide' " (click)="show = ! show"></div>
